import React from 'react';
import type { Tome } from '../data/kit';
import { Section, Tag } from './Shared';
import { Bat, Star } from './HalloweenDecor';
type TomeSectionProps = {
  tome: Tome;
  tone: 'cream' | 'white';
  reverse?: boolean;
};
export function TomeSection({
  tome,
  tone,
  reverse = false
}: TomeSectionProps) {
  return <Section id={tome.id} tone={tone} decor={<>
          <Bat className={`absolute top-10 w-12 text-brand-violet/10 ${reverse ? 'left-[5%]' : 'right-[5%]'}`} data-id="element-236" data-mp="2ndnr3dxdlfll" />
          <Star className={`absolute bottom-14 w-4 text-brand-orange/40 ${reverse ? 'right-[8%]' : 'left-[8%]'}`} data-id="element-237" data-mp="2x5k37swar68t" />
        </>} data-id="element-235" data-mp="2nefnus2pljdg">
      <div className="grid items-center gap-10 md:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-238" data-mp="3b5bdbijp02hj">
        <div className={`mx-auto w-full max-w-[340px] ${reverse ? 'md:order-2' : ''}`} data-id="element-239" data-mp="365gnzjfkfkyl">
          <img src={tome.cover} alt={tome.coverAlt} loading="lazy" className="h-auto w-full rounded-2xl shadow-soft" draggable={false} data-id="element-240" data-mp="1gqs7b5zxzgur" />
        </div>

        <div className={reverse ? 'md:order-1' : ''} data-id="element-241" data-mp="1btierhh9ap2p">
          <Tag variant="violet" data-id="element-242" data-mp="1qkn1wcq62lwh">{tome.label}</Tag>
          <h2 className="mt-4 text-[32px] font-extrabold leading-[1.1] text-brand-violet md:text-5xl" data-id="element-243" data-mp="1qly5ocjm3tnl">{tome.title}</h2>
          <p className="mt-2 text-lg font-medium leading-snug text-brand-ink md:text-xl" data-id="element-244" data-mp="1vgvaf79uzguo">{tome.subtitle}</p>
          <p className="mt-4 text-base leading-relaxed text-brand-ink/80 md:text-lg" data-id="element-245" data-mp="25914cmjo88ci">{tome.text}</p>

          <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3" data-id="element-246" data-mp="29amngpmstiv5">
            {tome.items.map(item => <li key={item} className="flex items-center gap-2.5 text-base font-medium text-brand-ink" data-id="element-247" data-mp="29cz6750drx99">
                <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-mint text-sm font-bold text-brand-violet" data-id="element-248" data-mp="2j8snf1p1oexd">
                  ✓
                </span>
                {item}.
              </li>)}
          </ul>

          <p className="mt-7 border-l-4 border-brand-orange pl-4 text-base font-medium italic leading-relaxed text-brand-violet md:text-lg" data-id="element-249" data-mp="owm1b7um4dqa">
            {tome.closing}
          </p>
        </div>
      </div>
    </Section>;
}